

<template>

  <MaquetteConfiguration/>
  
  <van-popup :z-index="2005" 
  v-if="this.$store.state.storeGlobal.StoreReductionPays"
  overlay-class="overlay_reduc" class="all_border_radius popup_reduc" 

  :style="{ 'background-image': 'url(' + this.$store.state.storeGlobal.StoreApi + '/images/infos/banniere_promo_fr.jpg)' }" closeable @close="this.$store.state.storeGlobal.StoreReductionPays = false" v-model:show="this.$store.state.storeGlobal.StoreReductionPays"  position="center"  >
    <van-row justify="center" align="center">
      <div v-html="this.$store.state.storeGlobal.StoreReductionMessage"></div>
</van-row>
</van-popup>

  
  <van-row class="row-btn-choice"  gutter="5" >
    
   
  

  
    <van-col span="1" class=" col-prk-add col-btn-addref" >
  
      <van-popover v-if="(StoreShowPrePanierListe.length == 0)" placement="top-start" v-model:show="showPopoverPrk">
  
     <span  @click="ClickPrkPopHover"> 
      <ajoutRefPrk popOverPlacement="right"/>
    </span>
      <van-divider  v-if="actifDevisBtn" />
  
      <span v-if="actifDevisBtn" @click="ClickPrkPopHover">
        <ajoutRefDevis popOverPlacement="right" />
      </span>
      <van-divider  v-if="actifAjoutNumSession" />
  
      <span v-if="actifAjoutNumSession" @click="ClickPrkPopHover">
        <ajoutNumSession popOverPlacement="right" />
      </span>
  
    <template #reference>
      <van-button class="btn-select-devis-prk" plain size="large" type="primary">
          <van-icon name="plus" />
      </van-button>
    </template>
  </van-popover>
    
    </van-col>
  
    <van-col span="6" class="p-l-10 col-btn-coa"  >
      <van-button class=" all_border_radius btn-select-config" :disabled="!StoreCableChoose || showCoB" @click="activePopUpCoA"  plain size="large">{{ $t('Connecteur A') }} </van-button>
    </van-col>
  
  
  
    <van-col  span="7">
      <van-button class="all_border_radius btn-select-config" :disabled="showCoA"  @click="activePopUpCable" plain size="large">{{ $t('Câble') }}  </van-button>
    
      </van-col>
  
  
    <van-col span="3">
      <van-button class="all_border_radius btn-select-config longueur_btn"  @click="activePopUpLong" :disabled="!StoreDiametreCoBChoose"  plain  size="large">{{ $t('Longueur') }}  </van-button>
    
      </van-col>
   
    
  
    <van-col span="6" class="p-r-10 col-btn-cob">
      <van-button class="all_border_radius btn-select-config" @click="activePopUpCoB"  :disabled="!StoreDiametreCoAChoose || showLong"  plain  size="large">{{ $t('Connecteur B') }}  </van-button>
    
    </van-col>
  
    <van-col span="1" class="col-btn-reset" >
     
      <ButtonReset/>
  </van-col>
  
   
  
  
  
  
    
  </van-row>
  
  <br/>
  
  
  <van-popup :z-index="2001" overlay-class="z_index_overlay"  v-bind:class="{ van_popup_choose_gigamedia_site : envWebName == 'Site Gigamedia' , van_popup_choose_gigamedia : envWebName == 'Formulaire' , van_popup_choose_webshop : envWebName == 'Webshop' , van_popup_choose_customer : envWebName == 'CustomerCare GIGAMEDIA' }"   closeable  v-model:show="varShowCoA" position="bottom">
  <SelectCoA v-if="varShowCoA"/>
  </van-popup>
  
  <van-popup :z-index="2001" overlay-class="z_index_overlay"  closeable  v-model:show="varShowCable" position="bottom" v-bind:class="{ van_popup_choose_gigamedia_site : envWebName == 'Site Gigamedia' , van_popup_choose_gigamedia : envWebName == 'Formulaire' , van_popup_choose_webshop : envWebName == 'Webshop' , van_popup_choose_customer : envWebName == 'CustomerCare GIGAMEDIA' }"   >
  <SelectCable/>
  </van-popup>
  
  <van-popup  :z-index="2001" overlay-class="z_index_overlay"   closeable  v-model:show="varShowLong" position="bottom" v-bind:class="{ van_popup_choose_gigamedia_site : envWebName == 'Site Gigamedia' , van_popup_choose_gigamedia : envWebName == 'Formulaire' , van_popup_choose_webshop : envWebName == 'Webshop' , van_popup_choose_customer : envWebName == 'CustomerCare GIGAMEDIA' }"  >
    <SelectLongueur @close-pop-up-longueur="closePopUpLongueur"  />
  </van-popup>
  
  <van-popup :z-index="2001" overlay-class="z_index_overlay"  closeable  v-model:show="varShowCoB" v-bind:class="{ van_popup_choose_gigamedia_site : envWebName == 'Site Gigamedia' , van_popup_choose_webshop : envWebName == 'Webshop' , van_popup_choose_gigamedia : envWebName == 'Formulaire' , van_popup_choose_customer : envWebName == 'CustomerCare GIGAMEDIA' }"  position="bottom"  >
   
    <SelectCoB  v-if="varShowCoB"/>
  </van-popup>
  
  <prePanier/>
  
  
  
  
  
  </template>
  
  
  <script>
  import MaquetteConfiguration from './maquette/MaquetteConfiguration.vue'
  import SelectCable from './selecteur/cable/SelectCable.vue'
  import SelectCoA from './selecteur/con_a/SelectCoA.vue'
  import SelectCoB from './selecteur/con_b/SelectCoB.vue'
  import SelectLongueur from './selecteur/longueur/SelectLongueur.vue'
  import prePanier from './prePanier/liste.vue'
  import ButtonReset from '../configurateur/maquette/ButtonReset.vue'
  import ajoutRefPrk from '../configurateur/prePanier/ajoutRefPrk.vue'
  import ajoutRefDevis from '../configurateur/prePanier/ajoutRefDevis.vue'
  import ajoutNumSession from '../configurateur/prePanier/ajoutNumSession.vue'
  
  export default {
    emits: ['close-pop-up-longueur' , 'closePopUpLongueur'],
    name:'configurateur',
    components: {
    MaquetteConfiguration,
     SelectCable,
     SelectCoA,
     SelectCoB,
     SelectLongueur,
     prePanier,
     ButtonReset,
     ajoutRefPrk,
     ajoutRefDevis,
     ajoutNumSession
    },
    data() {
      return {
        loadingHome:false,
       varShowCable : true,
        varShowCoA : false,
        varShowCoB : false,
        varShowLong : false,
        showPopoverPrk : false,
        showPopupReduction : false ,
        actifDevisBtn : false,
        actifAjoutNumSession : true,
        envWebName : false
      }
    },
    mounted () {
  this.envWebName = this.$store.state.storeGlobal.StoreEnvWeb
    },
    methods: {
      ClickPrkPopHover(){
        this.varShowCoA = false
        this.varShowCoB = false
        this.varShowLong = false
        this.varShowCable = false
      },
      closePopUpLongueur(data){
        this.varShowLong = data
      },
      activePopUpCable(){
        this.varShowCable = true;
        
      },
      activePopUpCoA(){
        this.varShowCoA = true;
      },
      activePopUpCoB(){
        this.varShowCoB = true
      },
      activePopUpLong(){
        this.varShowLong = true
      },
  
        },
  
        watch: {
          // à chaque fois que la question change, cette fonction s'exécutera
          CableLength: function (data) {
              if( data == true ){
            
                this.varShowCoA = false
                this.varShowCoB = false
                this.varShowLong = false
  
                this.varShowCable = true
              }
            },
          showCoA: function (data) {
              if( data == true ){
               
                this.varShowCable = false
                this.varShowCoB = false
                this.varShowLong = false
  
                this.varShowCoA = true
              }
            },
          showCoB: function (data) {
              if( data == true ){
              
                this.varShowCable = false
                this.varShowCoA = false
                this.varShowLong = false
  
                this.varShowCoB = true
              }
            },
          showLong: function (data) {
              if( data == true ){
              
                this.varShowCable = false
                this.varShowCoA = false
                this.varShowCoB = false
  
                this.varShowLong = true
              }
            },
            showAfterLong: function (data) {
              if( data == true ){
           
                this.varShowLong = false
              }
            }
  
    },
    computed: {
  
            // apparition choix cable si reset
              envWebNametest(){ 
                 return this.$store.state.storeGlobal.StoreEnvWeb.length == 0
                  ?  this.$store.state.storeGlobal.StoreEnvWeb
                  :  false
              },
              CableLength(){
                 return this.$store.state.storeCable.cable.length == 0
                  ?  true
                  :  false
              },
              showCable(){
                return this.globalFunction.existKeyInArray("euroclass", this.$store.state.storeCable.cable) 
                  ?  false
                  :  true
              },
  
              showCoA(){
                return this.globalFunction.existKeyInArray("euroclass", this.$store.state.storeCable.cable) 
                  ?  true
                  :  false
              },
  
              showCoB(){
                return this.globalFunction.existKeyInArray("diametre", this.$store.state.storeCoA.coA) 
                  ?  true
                  :  false
              },
  
              showLong(){
                return this.globalFunction.existKeyInArray("diametre", this.$store.state.storeCoB.coB) 
                  ?  true
                  :  false
              },
  
              showAfterLong(){
                return this.globalFunction.existKeyInArray("longueur", this.$store.state.storeLongueur.longueur) 
                  ?  true
                  :  false
              },
  
  
  
              StoreCableChoose() {
                return this.globalFunction.existKeyInArray("euroclass", this.$store.state.storeCable.cable) 
                  ?  true
                  :  false
              },
              StoreCableChooseShowCoA() {
                return this.globalFunction.existKeyInArray("euroclass", this.$store.state.storeCable.cable) 
                  ?  this.cableChoose
                  : false
              },
              /** Co a choisie */
              StoreDiametreCoAChoose() {
                return this.globalFunction.existKeyInArray("diametre", this.$store.state.storeCoA.coA) 
                  ?  true
                  :  false
              },
              /** Co b choisie */
              StoreDiametreCoBChoose() {
                return this.globalFunction.existKeyInArray("diametre", this.$store.state.storeCoB.coB) 
                  ?  true
                  :  false
              },
  
  
              /** SHOW POPUP */
              StoreShowPopupLong() {
                return this.globalFunction.existKeyInArray("diametre", this.$store.state.storeCoB.coB) 
                  ?  true
                  :  false
  
              },
  
               /** PrePanier du store */
              StoreShowPrePanierListe() {
                      return this.$store.state.storePrePanier.StoreShowPrePanierListe
                  },
  
            }
  
  
  }
  </script>
  
  <style>
  .btn-select-config{
    box-shadow: 0px 0px 13px 1px #00000036;
      border: none !important;
      border-radius: 9px !important;
  }
  .row-btn-choice{
    font-weight: bolder;
  }
  .van-button--disabled.btn-select-config {
    box-shadow: 0px 0px 0px 0px  #00000036 !important;
  }
  .van-overlay{
    background: rgba(0, 0, 0, 0) !important;
  }
  .disabled{
    background-color:rgb(85, 84, 84) !important;
  }
  .item-index{
      z-index:9999;
    }
    .van-tab__text{
      text-align: center;
    }
  </style>